var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17202 6.41669H8.16602",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.672 9.33331H4.66602",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64517 5.42681C3.37869 6.03058 3.48942 6.70205 3.89249 6.92658C4.29557 7.1511 4.83835 6.84363 5.10482 6.23988C5.3713 5.63613 5.26057 4.96468 4.8575 4.74015C4.45443 4.51562 3.91165 4.82305 3.64517 5.42681Z",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68626 9.25863C7.45899 9.69735 7.62034 10.217 8.0467 10.4194C8.47306 10.6218 9.00296 10.4301 9.23023 9.99141C9.45749 9.55269 9.29614 9.033 8.86979 8.83064C8.44343 8.62828 7.91353 8.8199 7.68626 9.25863Z",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 12.8334C3.77842 12.8334 1.16675 10.2217 1.16675 7.00002C1.16675 3.77836 3.77842 1.16669 7.00008 1.16669C7.14107 1.16669 7.22607 1.32042 7.17269 1.45094C7.06145 1.72316 7.00008 2.0211 7.00008 2.33335C7.00008 3.62202 8.04477 4.66669 9.33342 4.66669C9.65297 4.66669 9.95752 4.60245 10.2348 4.48618C10.3535 4.43646 10.5001 4.53809 10.5001 4.66669C10.5001 5.63318 11.2836 6.41669 12.2501 6.41669C12.3165 6.41669 12.382 6.41301 12.4464 6.40578C12.6299 6.3853 12.8154 6.50203 12.8251 6.68648C12.8306 6.79031 12.8334 6.89485 12.8334 7.00002C12.8334 10.2217 10.2217 12.8334 7.00008 12.8334Z",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealIcon);
export default __webpack_public_path__ + "static/media/meal_icon.91b7dd1eb58f16e2741765775b4635bc.svg";
export { ForwardRef as ReactComponent };